/* eslint-disable no-undef */
// project imports
import services from 'utils/mockAdapter';
// import { waste } from 'data/e-commerce';
import waste from 'data/waste.json';

// ==============================|| MOCK SERVICES ||============================== //

services.onGet('/api/waste/list').reply(200, { waste });

services.onPost('/api/waste/filter').reply((config) => {
  try {
    const { filter } = JSON.parse(config.data);

    if (filter.sort === 'high') {
      waste.sort((a, b) => Number(b.amount) - Number(a.amount));
    }

    if (filter.sort === 'low') {
      waste.sort((a, b) => Number(a.amount) - Number(b.amount));
    }

    // if (filter.sort === 'popularity') {
    //   waste.sort((a, b) => Number(b.popularity) - Number(a.popularity));
    // }

    // if (filter.sort === 'stock') {
    //   waste.sort((a, b) => Number(b.stock) - Number(a.stock));
    // }

    // if (filter.sort === 'new') {
    //   waste.sort((a, b) => Number(b.new) - Number(a.new));
    // }

    const results = waste.filter((waste) => {
      let searchMatches = true;

      if (filter.search) {
        const properties = ['name', 'physicalState', 'type', 'classification', 'unit', 'amount'];
        let containsQuery = false;

        properties.forEach((property) => {
          if (waste[property] && waste[property].toString().toLowerCase().includes(filter.search.toString().toLowerCase())) {
            containsQuery = true;
          }
        });

        if (!containsQuery) {
          searchMatches = false;
        }
      }

      // const genderMatches = filter.gender.length > 0 ? filter.gender.some((item) => item === waste.gender) : true;
      // const categoriesMatches =
      //   filter.categories.length > 0 && filter.categories.some((category) => category !== 'all')
      //     ? filter.categories.some((category) => waste.categories.some((item) => item === category))
      //     : true;
      // const colorsMatches = filter.colors.length > 0 ? filter.colors.some((color) => waste.colors.some((item) => item === color)) : true;

      // const minMax = filter.price ? filter.price.split('-') : '';
      // const priceMatches = filter.price ? waste.amount >= minMax[0] && waste.amount <= minMax[1] : true;
      // const ratingMatches = filter.rating > 0 ? waste.rating >= filter.rating : true;

      return searchMatches;
    });

    return [200, results];
  } catch (err) {
    console.error(err);
    return [500, { message: 'Internal server error' }];
  }
});

services.onPost('/api/waste/details').reply((config) => {
  try {
    const { id } = JSON.parse(config.data);

    let results;
    if (id === 'default') {
      [results] = waste;
    } else {
      // eslint-disable-next-line
      [results] = waste?.filter((waste) => waste.id === Number(id));
    }

    return [200, results];
  } catch (err) {
    console.error(err);
    return [500, { message: 'Internal server error' }];
  }
});

services.onPost('/api/waste/related').reply((config) => {
  try {
    const { id } = JSON.parse(config.data);

    const results = waste.filter((waste) => waste.id !== Number(id));

    return [200, results];
  } catch (err) {
    console.error(err);
    return [500, { message: 'Internal server error' }];
  }
});

services.onPost('/api/waste/list/single').reply((config) => {
  try {
    const result = waste.find((e) => e.id === Number(config.data));
    return [200, result];
  } catch (err) {
    console.error(err);
    return [500, { message: 'Internal server error' }];
  }
});

services.onPost('/api/waste/insert').reply((config) => {
  try {
    let list = JSON.parse(config.data);
    list = {
      ...list,
      id: waste.length + 1
    };
    waste.push(list);
    return [200, { list }];
  } catch (err) {
    console.error(err);
    return [500, { message: 'Internal server error' }];
  }
});

services.onPost('/api/waste/update').reply((config) => {
  try {
    const list = JSON.parse(config.data);

    let NewProduct = null;
    _.map(waste, (_list) => {
      if (_list.id === list.id) {
        _.assign(_list, { ...list });
        NewProduct = _list;
      }
      return _list;
    });

    return [200, { NewProduct }];
  } catch (err) {
    console.error(err);
    return [500, { message: 'Internal server error' }];
  }
});
